import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Divider, Grid, Typography } from "@mui/material";
import { updateAdministrationTools } from "@/Settings/api/AdministrationTools/mutations";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import DaysPicker from "@/Layouts/components/DaysPicker/DaysPicker";
import { errorLogger } from "@/Common/helpers/logger";

//PropTypes
import PropTypes from "prop-types";

const CommonDivider = () => <Divider sx={{ borderWidth: "1px", marginLeft: "-0", marginTop: "30px" }} variant="middle" />;

const extraClasses = "!font-montserrat !text-[16px] !text-default !font-medium !mb-[12px]";
export default function OpportunityMining(props) {
	const locationId = useSelector((state) => state.location.location)?.locationId;
	const [isChecked, setIsChecked] = useState(false);
	const [provider, setProvider] = useState(null);
	const [days, setDays] = useState(null);

	const { mutate: mutateProvider, isPending: isLoadingProvider } = useMutation({
		mutationKey: ["administrationTools", locationId],
		mutationFn: (input) => updateAdministrationTools(locationId, input),
		onError: (error) => errorLogger(error.message),
		onSuccess: (data) => {
			const providerName = data?.integrations?.opportunityMining?.provider.map((item) => item.providerName);
			setProvider(...providerName);
		},
	});

	const { mutate: mutateDays, isPending: isLoadingDays } = useMutation({
		mutationKey: ["administrationTools", locationId],
		mutationFn: (input) => updateAdministrationTools(locationId, input),
		onError: (error) => errorLogger(error.message),
		onSuccess: (data) => {
			const configDays = data?.integrations?.opportunityMining?.provider.map((item) => item.configuration);
			const daysData = configDays[0].map((item) => item.associationWindow);
			setDays(...daysData);
		},
	});

	const updateData = (value) => {
		if (provider !== null) {
			const input = {
				integrations: {
					...props?.settings?.integrations,
					opportunityMining: {
						provider: {
							providerName: provider,
							configuration: {
								associationWindow: value["label"],
							},
						},
					},
				},
			};
			mutateDays(input);
		}
	};

	const handleCheckSelect = (selected) => {
		if (selected?.id && selected?.id !== provider) {
			const input = {
				integrations: {
					...props?.settings?.integrations,
					opportunityMining: {
						provider: {
							providerName: selected.label,
						},
					},
				},
			};
			mutateProvider(input);
		}
		setIsChecked(selected?.id === "AutoAlert");
	};

	const handleClearClick = (option) => {
		if (option === "autoAlert") {
			const input = { integrations: { ...props?.settings?.integrations, opportunityMining: {} } };
			mutateProvider(input);
			setIsChecked(false);
			setDays(null);
		}
	};

	useEffect(() => {
		if (!locationId) {
			return;
		}
		const providerName = props?.settings?.integrations?.opportunityMining?.provider?.at(0)?.providerName;
		if (!providerName) {
			setProvider(null);
			setDays(null);
			setIsChecked(null);
		}

		if (providerName) {
			setProvider(providerName);
			setDays(
				providerName === "AutoAlert"
					? props?.settings?.integrations?.opportunityMining?.provider?.at(0)?.configuration[0]?.associationWindow
					: null
			);
			setIsChecked(providerName === "AutoAlert");
		}
	}, [locationId, setProvider, props]);

	return (
		<>
			<Grid id="commission-payout" container className={props.classes.departmentContainer} columnSpacing={2}>
				<Grid item>
					<Typography className={`${props.classes.label} ${extraClasses}`}>{props.title}</Typography>
					<SmartSelector
						selectBy={"id"}
						showBy={"label"}
						options={[
							{ id: "AutoAlert", label: "AutoAlert" },
							// This 2 commented will be used in others subsection
							// { id: "Reynolds", label: "Reynolds" },
							// { id: "Other", label: "Other" },
						]}
						selected={provider ? { id: provider, label: provider } : null}
						inputProps={{
							placeholder: "Select a provider",
						}}
						listBoxProps={{
							sx: { maxHeight: "220px" },
						}}
						clearable={!props?.noClearIcon}
						disabled={isLoadingProvider}
						error={props?.error}
						sx={{ minWidth: "200px" }}
						onChangeAction={(selected) => {
							if (selected) {
								handleCheckSelect(selected);
							} else {
								handleClearClick("autoAlert");
							}
						}}
					/>
				</Grid>
			</Grid>
			{isChecked && (
				<Grid item xs={12}>
					{CommonDivider()}
					<Typography className={"regular-montserrat-label fs-18"} mt={2.5} mb={3}>
						Synchronization
					</Typography>
					<Typography className={`${props.classes.label} ${extraClasses}`} mb={2}>
						Association Window
					</Typography>
					<Grid item className="position-mapping-payroll-column" sx={{ position: "relative" }}>
						<DaysPicker
							daysMax={91}
							initialValue={days}
							readOnly={isLoadingDays}
							updateData={updateData}
							name={"associationWindow"}
						/>
					</Grid>
				</Grid>
			)}
		</>
	);
}

OpportunityMining.propTypes = {
	settings: PropTypes.object,
	classes: PropTypes.shape({
		departmentContainer: PropTypes.string,
		label: PropTypes.string,
	}),
	title: PropTypes.string,
	noClearIcon: PropTypes.bool,
	error: PropTypes.bool,
};
